/**
 *
 * ArticleLinks
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';
import ResourceItemInfoButton from 'components/ResourceItemInfoButton';
import ResourceLinks from 'components/ResourceLinks';

function ArticleLinks(props) {
  const { data, section, organization, className } = props;
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const item = _get(data, '0', {});
  const {
    fields: { name, url = '', blog, type },
  } = item;
  const trackCommonProps = {
    trackMessage: 'Resource Page - Exited',
    resourceType: 'article',
    name,
    blog,
    subtype: type,
    data: item,
  };
  return (
    <ResourceLinks
      data={data}
      section={section}
      subtitle={_get(resourceItemPageSiteCopy, 'pageCopy.articleLinksHeader')}
      className={className}
    >
      {url && (
        <ResourceItemInfoButton
          url={url}
          type="website"
          exitPage="website"
          showLeavingDialog
          organization={organization}
          {...trackCommonProps}
        />
      )}
    </ResourceLinks>
  );
}

ArticleLinks.propTypes = {
  data: PropTypes.object,
  section: PropTypes.string,
};

export default ArticleLinks;
